<template>
  <svg aria-hidden="true" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" ...attributes>
    <ellipse cx="10.9777" cy="11" rx="10.9777" ry="11" fill="#e5e5e5"></ellipse>
    <path
      d="M16.5 11H14.3L12.65 16L9.35 6L7.7 11H5.5"
      stroke="#000"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
</template>
